import React from 'react';
import { Box, Flex, Relative, Text } from 'pcln-design-system';
import { PriceCurrency, PriceCurrencyStrikeThrough, TextStrikeThrough } from '../../HotlListingCard.styles';
import PricelineLogo from '../../../../svgs/PricelineLogo';
import VipLogo from '../../../../svgs/VipLogo';
const Price = ({
  price,
  totalPrice,
  currency,
  strikeThroughPrice,
  savingsPct,
  priceDisplayRegulation,
  nightlyRateIncludingTaxesAndFees,
  nightlyRateExcludingTaxesAndFees,
  strikePriceExcludingTaxesAndFees,
  displayStrikePrice,
  strikePriceIncludingTaxesAndFees
}) => {
  let parsedStrikePrice = 0;
  let parsedNightlyRate = 0;
  let parsedTotalPrice = 0;
  const nightlyRate = priceDisplayRegulation === 'TOTAL_PRICE_PROMINENT' ? nightlyRateIncludingTaxesAndFees : nightlyRateExcludingTaxesAndFees !== null && nightlyRateExcludingTaxesAndFees !== void 0 ? nightlyRateExcludingTaxesAndFees : price;
  const resolvedStrikePrice = priceDisplayRegulation === 'TOTAL_PRICE_PROMINENT' ? strikePriceIncludingTaxesAndFees : strikePriceExcludingTaxesAndFees !== null && strikePriceExcludingTaxesAndFees !== void 0 ? strikePriceExcludingTaxesAndFees : strikeThroughPrice;
  if (!isNaN(Number(resolvedStrikePrice))) {
    parsedStrikePrice = Math.round(parseInt(resolvedStrikePrice));
  }
  if (!isNaN(Number(nightlyRate))) {
    parsedNightlyRate = Math.round(parseInt(nightlyRate));
  }
  if (!isNaN(Number(totalPrice))) {
    parsedTotalPrice = Math.round(parseInt(totalPrice));
  }
  return React.createElement(Flex, {
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 1
  }, React.createElement(Box, {
    width: '65%'
  }, React.createElement(Box, {
    width: 1
  }, savingsPct ? React.createElement(Box, null, React.createElement(Flex, {
    alignItems: 'center',
    "data-testid": 'PENNY_PCLN_VIPICON'
  }, React.createElement(Relative, {
    pr: 2,
    top: '3px'
  }, React.createElement(PricelineLogo, {
    width: '60px',
    height: '20px'
  })), React.createElement(Box, null, React.createElement(VipLogo, {
    width: '24px',
    height: '24px'
  })), React.createElement(Relative, {
    top: '-3px'
  }, React.createElement(Text, {
    color: 'pricePrimary.base',
    lineHeight: '22px',
    ml: 1
  }, React.createElement(Text.span, {
    fontSize: 2,
    fontWeight: 'bold'
  }, parseInt(savingsPct, 10), "% Off")))), React.createElement(Flex, null, React.createElement(Text, {
    fontSize: 0,
    color: 'text.light'
  }, "Lower price because you're a VIP!"))) : null)), React.createElement(Box, {
    textAlign: 'right'
  }, parsedStrikePrice > 0 ? React.createElement(Relative, null, React.createElement(TextStrikeThrough, {
    lineHeight: '22px'
  }, React.createElement(PriceCurrencyStrikeThrough, {
    fontSize: '8px',
    fontWeight: 'bold'
  }, currency), React.createElement(Text.span, {
    fontSize: 1,
    fontWeight: 'bold'
  }, parsedStrikePrice))) : null, parsedNightlyRate ? React.createElement(Text, {
    color: 'pricePrimary.base',
    lineHeight: '22px'
  }, React.createElement(PriceCurrency, {
    fontSize: 0,
    fontWeight: 'bold'
  }, currency), React.createElement(Text.span, {
    fontSize: 4,
    fontWeight: 'bold'
  }, parsedNightlyRate)) : null, parsedTotalPrice ? React.createElement(Text, {
    fontSize: 0,
    lineHeight: '16px',
    color: 'text.light'
  }, "Total: ", currency, parsedTotalPrice) : null));
};
export default Price;